// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1tzzn","fileBtn":"File_fileBtn__1Qxvr","closeBtn":"File_closeBtn__1HRwF","fileSelected":"File_fileSelected__3CnM_","disabled":"File_disabled__37e4A"};